module.exports = __webpack_public_path__ + "static/media/beach2.5d03a044.png";